import React, { useContext } from 'react';
import T from 'prop-types';

import { isEmpty, pick } from 'lodash-es';

import AlertBlock from '../../../../../components/AlertBlock';
import { SortableTable } from '../../../../../components/SortableTable';
import ArrowChange from '../../../../../components/ArrowChange';
import MediaObject from '../../../../../components/MediaObject';
import QuickViewContext from '../../../../../components/QuickView/QuickViewContext';
import { appsColumns } from '../configs/table-config';
import { initParams } from '../configs';

const { allowAppQuickView } = initParams;


const TopPublishersTable = ({
  tableData,
  report,
  onShowMore,
}) => {
  const { onAppQuickViewOpen, onPubQuickViewOpen } = useContext(QuickViewContext);

  const emptyCell = <span>-</span>;

  const handleShowMore = () => {
    onShowMore();
  };
  const {
    free,
    paid,
    grossing,
  } = report.data;

  const rowsData = {
    free: free.ranks.slice(0, 50),
    paid: paid.ranks.slice(0, 50),
    grossing: grossing.ranks.slice(0, 50),
  };

  const renderApp = (app) => {
    if (!app) return null;

    const appProperties = pick(app.general_data, ['kind', 'name', 'publisher_name', 'publisher_id', 'icon_url', 'cdn_images', 'icon_cdn_path']);
    if (!appProperties.name) return null;
    return (
      <MediaObject
        {...appProperties}
        app_id={app.id}
        store={app.store}
        appQuickViewAllowed={allowAppQuickView}
        withoutStore
        icon_url={appProperties.cdn_images ? appProperties.cdn_images['64x64'] : appProperties.icon_url}
        icon_url_2x={appProperties.cdn_images ? appProperties.cdn_images['128x128'] : (appProperties.icon_url_2x || appProperties.icon_url)}
        onAppQuickViewOpen={onAppQuickViewOpen}
        onPubQuickViewOpen={onPubQuickViewOpen}
      />
    );
  };

  const rows = rowsData.free.map((td, i) => ({
    rank: i + 1,
    free: (rowsData.free[i] && renderApp(tableData[rowsData.free[i].app_id])) || emptyCell,
    free_change: (rowsData.free[i] && (
      <ArrowChange
        change={rowsData.free[i].delta}
        precision={2}
        upArrowClass="hicon-angle-up"
        downArrowClass="hicon-angle-down"
        units=""
      />
    )) || emptyCell,
    paid: (rowsData.paid[i] && renderApp(tableData[rowsData.paid[i].app_id])) || emptyCell,
    paid_change: (rowsData.paid[i] && (
      <ArrowChange
        change={rowsData.paid[i].delta}
        precision={2}
        upArrowClass="hicon-angle-up"
        downArrowClass="hicon-angle-down"
        units=""
      />
    )) || emptyCell,
    grossing: (rowsData.grossing[i] && renderApp(tableData[rowsData.grossing[i].app_id])) || emptyCell,
    grossing_change: (rowsData.grossing[i] && (
      <ArrowChange
        change={rowsData.grossing[i].delta}
        precision={2}
        upArrowClass="hicon-angle-up"
        downArrowClass="hicon-angle-down"
        units=""
      />
    )) || emptyCell,
  }));

  return (
    <div className="top-charts-main">
      <div className="top-charts-table-box">
        {!isEmpty(report) ? (
          <div className="table-responsive pos-rel">
            <SortableTable
              tableClassName="table-default table-hover sticky-header top-charts"
              rows={rows}
              columns={appsColumns}
              emptyStateText="No data to display"
              showMoreCellColSpan={10}
              showEmptyCells={false}
              showMoreCellSimplified
              hasShowMoreCell
              initialRowsLimit={50}
              onShowMore={handleShowMore}
            />
          </div>
        ) : (
          <AlertBlock type="warning" iconClass="hicon-warning">
            <p>Sorry, the Top Apps report is not available for apps matching these criteria.</p>
          </AlertBlock>
        )}
      </div>
    </div>
  );
};

TopPublishersTable.propTypes = {
  tableData: T.object.isRequired,
  report: T.object.isRequired,
  onShowMore: T.func.isRequired,
};

export default TopPublishersTable;
